// extracted by mini-css-extract-plugin
module.exports = {"icon":"src-hellospa-icons-icons__icon--3vTqR"};